var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Plugin } from "@atlassiansox/microscopekit";
import { ResilienceCreatePage } from "./service/pages/resilience-create-page";
import { ResiliencePage } from "./service/pages/resilience-page";
import { MyServiceNavigation } from "./service/navigation/resilience-service-links";
import { TemplateDetailsPage } from "./service/pages/template-details-page";
import { WargameDetailsPage } from "./service/pages/resilience-wargame-page";
import { WargameNotificationPage } from "./service/pages/resilience-notifications";
import { ExercisePage } from "./service/pages";
import { ServiceIdContextProvider } from "./service/hooks";
import { TemplateEditPage } from "./service/pages/template-edit-page";
import { ResilienceHomePage } from "./service/pages/resilience-home-page";
import { CronosPage } from "./service/pages/cronos-page";
var routes = [
    {
        path: "resilience",
        component: ResilienceHomePage
    },
    {
        path: "resilience/ondemand",
        component: ResiliencePage
    },
    {
        path: "resilience/continuous-chaos",
        component: CronosPage
    },
    {
        path: "resilience/continuous-chaos/wargame-details",
        component: WargameDetailsPage
    },
    {
        path: "resilience/ondemand/create-template",
        component: ResilienceCreatePage
    },
    {
        path: "resilience/ondemand/template-details",
        component: TemplateDetailsPage
    },
    {
        path: "resilience/ondemand/wargame-details",
        component: WargameDetailsPage
    },
    {
        path: "resilience/ondemand/notifications",
        component: WargameNotificationPage
    },
    {
        path: "resilience/ondemand/exercise/:id",
        component: ExercisePage
    },
    {
        path: "resilience/ondemand/template-edit",
        component: TemplateEditPage
    }
];
// Microscope imports your plugin from here
var MyPlugin = /** @class */ (function (_super) {
    __extends(MyPlugin, _super);
    function MyPlugin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyPlugin.prototype.render = function () {
        return (React.createElement(Plugin, { id: "resilience", serviceContainer: {
                routes: routes.map(function (_a) {
                    var path = _a.path, Component = _a.component;
                    return ({
                        path: path,
                        component: function (_a) {
                            var id = _a.id;
                            return (React.createElement(ServiceIdContextProvider, { value: id },
                                React.createElement(Component, { id: id })));
                        }
                    });
                }),
                navigation: [
                    {
                        id: "service-navs",
                        component: MyServiceNavigation
                    }
                ]
            } }));
    };
    return MyPlugin;
}(React.Component));
export default MyPlugin;
